import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => {
  return {
    CompanyOperationalPerformanceFilter: {
      display: 'flex',
      alignItems: 'center',
      '& .MuiSelect-select': {
        background: '#fff',
        padding: '8px 24px 8px 10px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
      },
      '& .MuiSvgIcon-root': {
        color: '#61B3CD',
      },
    },
    CustomMenuItemText: {
      '& .MuiTypography-root': {
        color: '#4e5054',
        fontSize: '13px',
      },
    },
  };
});

export default useStyles;
